import { LinkItem } from '@occc/ui-design-system';

import { routeCreator as scanDataRouteCreator } from '../../scan-data.router';

export const buildScanDataPastSubmissionBreadcrumbs = (label: string): LinkItem[] => [
  {
    label: 'Tobacco Offers',
    to: scanDataRouteCreator.base(),
  },
  { label },
];
